import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Injectable, Inject } from '@angular/core';
import { API_SERVER_TOKEN } from '../api-server-token';
import { Profile } from '@portal-front-end/models';
import { Update } from '@ngrx/entity';
import { map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class ProfilesApiService {

    constructor(
        private readonly http: HttpClient,
        @Inject(API_SERVER_TOKEN) private apiServer: string
    ) { }

    private readonly PROFILE_API_URL = `${this.apiServer}/profiles`;

    getAllProfiles(orgId: string): Observable<Profile[]> {
        return this.http.get<Profile[]>(`${this.PROFILE_API_URL}/search`,
            { 'params': { 'organisationId': orgId } }
        );
    }
    // profiles of the organisation and all its child organisations
    getProfilesForOrgTree(orgId: string): Observable<Profile[]> {
        return this.http.get<Profile[]>(`${this.PROFILE_API_URL}/search-tree`,
            { 'params': { 'organisationId': orgId } }
        );
    }
    getAllProfilesData(): Observable<Profile[]> {
        return this.http.get<Profile[]>(`${this.PROFILE_API_URL}`
        );
    }
    createProfile(newProfile: Profile): Observable<Profile> {
        return this.http.post<Profile>(`${this.PROFILE_API_URL}`, newProfile);
    }

    deleteProfile(id: string | number): Observable<string | number> {
        return this.http.delete<string | number>(`${this.PROFILE_API_URL}/${id}`)
            .pipe(map(() => id));
    }

    updateProfile(profileId: number, profileName: string, supplierInvoiceFee: number, email: string): Observable<Profile> {
        return this.http.put<Profile>(`${this.PROFILE_API_URL}/${profileId}`, {
            profileId, profileName, supplierInvoiceFee, email
        });
    }
}
